import clsx from 'clsx';
import { X } from 'lucide-react';

import { useToasts } from './store';
import styles from './toasts.module.css';

/**
 * Toast stack — pinned to the bottom-right of its parent (the world
 * mount). Each toast shows kind-coloured styling and a manual dismiss.
 * `pointer-events: none` on the stack lets clicks pass through empty
 * space; individual toasts re-enable pointer events so the dismiss
 * button works.
 */
export function ToastStack(): JSX.Element {
  const toasts = useToasts((s) => s.toasts);
  const dismiss = useToasts((s) => s.dismiss);
  return (
    <div className={styles.stack} aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={clsx(styles.toast, styles[`kind_${t.kind}`])}
          role="status"
        >
          <span className={styles.message}>{t.message}</span>
          <button
            type="button"
            className={styles.closeButton}
            onClick={() => dismiss(t.id)}
            aria-label="Dismiss"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
